import _css from "@emotion/css";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "dataset", "draggableProps", "innerRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Component } from 'react';
import deepEqual from 'react-fast-compare';
import { styleReducerNoOp, withContentTheme } from '../../../theme';
import { jsx as ___EmotionJSX } from "@emotion/core";

var isString = function isString(x) {
  return typeof x === 'string';
};

var ComponentSwitch = function ComponentSwitch(_ref) {
  var as = _ref.as,
      dataset = _ref.dataset,
      draggableProps = _ref.draggableProps,
      innerRef = _ref.innerRef,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isElement = isString(as);
  var props = isElement ? _objectSpread(_objectSpread({}, dataset), rest) : _objectSpread({
    innerRef: innerRef,
    dataset: dataset,
    draggableProps: draggableProps
  }, rest); // only pass the actual `ref` to an element, it's the responsibility of the
  // component author to use `innerRef` where applicable

  var ref = isElement ? innerRef : null;
  var ElementOrComponent = as;
  return ___EmotionJSX(ElementOrComponent, _extends({
    ref: ref
  }, draggableProps, props));
};

var getItemComponentProps = function getItemComponentProps(props) {
  var nonComponentKeys = ['isActive', 'isHover', 'isSelected', 'isFocused', 'isDragging', 'theme'];
  var componentProps = {};
  Object.keys(props).forEach(function (prop) {
    if (!nonComponentKeys.includes(prop)) {
      componentProps[prop] = props[prop];
    }
  });
  return componentProps;
};

var ItemPrimitive = /*#__PURE__*/function (_Component) {
  _inherits(ItemPrimitive, _Component);

  var _super = _createSuper(ItemPrimitive);

  function ItemPrimitive() {
    _classCallCheck(this, ItemPrimitive);

    return _super.apply(this, arguments);
  }

  _createClass(ItemPrimitive, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !deepEqual(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          After = _this$props.after,
          Before = _this$props.before,
          CustomComponent = _this$props.component,
          dataset = _this$props.dataset,
          draggableProps = _this$props.draggableProps,
          href = _this$props.href,
          innerRef = _this$props.innerRef,
          isActive = _this$props.isActive,
          isDragging = _this$props.isDragging,
          isHover = _this$props.isHover,
          isSelected = _this$props.isSelected,
          isFocused = _this$props.isFocused,
          onClick = _this$props.onClick,
          spacing = _this$props.spacing,
          styleReducer = _this$props.styles,
          subText = _this$props.subText,
          target = _this$props.target,
          text = _this$props.text,
          theme = _this$props.theme;
      var mode = theme.mode,
          context = theme.context;
      var presentationProps = {
        isActive: isActive,
        isDragging: isDragging,
        isHover: isHover,
        isSelected: isSelected,
        isFocused: isFocused,
        spacing: spacing
      };
      var defaultStyles = mode.item(presentationProps)[context];
      var styles = styleReducer(defaultStyles, presentationProps, theme); // base element switch

      var itemComponent = 'div';
      var itemProps = {
        draggableProps: draggableProps,
        innerRef: innerRef,
        dataset: dataset
      };
      var _this$props2 = this.props,
          afterGoTo = _this$props2.afterGoTo,
          spinnerDelay = _this$props2.spinnerDelay,
          incomingView = _this$props2.incomingView;
      var propsForAfterComp = {
        afterGoTo: afterGoTo,
        spinnerDelay: spinnerDelay,
        incomingView: incomingView
      };

      if (CustomComponent) {
        itemComponent = CustomComponent;
        itemProps = getItemComponentProps(this.props);
      } else if (href) {
        itemComponent = 'a';
        itemProps = {
          dataset: dataset,
          href: href,
          onClick: onClick,
          target: target,
          draggableProps: draggableProps,
          innerRef: innerRef
        };
      } else if (onClick) {
        itemComponent = 'button';
        itemProps = {
          dataset: dataset,
          onClick: onClick,
          draggableProps: draggableProps,
          innerRef: innerRef
        };
      }

      return ___EmotionJSX(ComponentSwitch, _extends({
        as: itemComponent,
        css: /*#__PURE__*/_css({
          '&&': styles.itemBase
        }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
      }, itemProps), !!Before && ___EmotionJSX("div", {
        css: styles.beforeWrapper
      }, ___EmotionJSX(Before, presentationProps)), ___EmotionJSX("div", {
        css: styles.contentWrapper
      }, ___EmotionJSX("div", {
        css: styles.textWrapper
      }, text), !!subText && ___EmotionJSX("div", {
        css: styles.subTextWrapper
      }, subText)), !!After && ___EmotionJSX("div", {
        css: styles.afterWrapper
      }, ___EmotionJSX(After, _extends({}, presentationProps, propsForAfterComp))));
    }
  }]);

  return ItemPrimitive;
}(Component);

_defineProperty(ItemPrimitive, "defaultProps", {
  dataset: {
    'data-testid': 'NavigationItem'
  },
  isActive: false,
  isDragging: false,
  isHover: false,
  isSelected: false,
  isFocused: false,
  spacing: 'default',
  styles: styleReducerNoOp,
  text: ''
});

export { ItemPrimitive as ItemPrimitiveBase };
export default withContentTheme(ItemPrimitive);